import { useState } from 'react';
import {
  Grid,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import RepentanceRequestForm from './RepentanceRequestForm';
import TermTDH from '@shared/components/TermsConditions/TermTDH';

const Legals = () => {
  const [modalType, setModalType] = useState(null);

  const handleClose = () => setModalType(null);

  const items = [
    {
      label: 'Ley N° 24.240',
      link:
        'https://servicios.infoleg.gob.ar/infolegInternet/anexos/0-4999/638/texact.htm',
    },
    {
      label: 'Términos y Condiciones Generales',
      action: 'terms',
    },
    {
      label: 'Botón de Arrepentimiento',
      action: 'repent',
    },
  ];

  const modalContentMap = {
    terms: <TermTDH />,
    repent: <RepentanceRequestForm handleClose={handleClose} />,
  };

  const modalTitleMap = {
    terms: 'Términos y Condiciones Generales',
    repent: 'Botón de Arrepentimiento',
  };

  const linkSx = {
    color: 'rgba(255,255,255,0.65)',
    fontSize: { xs: '12px', md: '13px' },
    cursor: 'pointer',
    textDecoration: 'none',
    transition: 'color 0.2s',
    '&:hover': { color: '#fff' },
  };

  const dotSx = {
    color: 'rgba(255,255,255,0.3)',
    fontSize: '12px',
    userSelect: 'none',
  };

  return (
    <>
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: { xs: 1.5, md: 0 },
          pt: { xs: 2.5, md: 3 },
          pb: { xs: 1.5, md: 2 },
        }}
      >
        {items.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: { xs: 1.5, md: 2 },
            }}
          >
            {item.action ? (
              <Typography
                component="span"
                onClick={() => setModalType(item.action)}
                sx={linkSx}
              >
                {item.label}
              </Typography>
            ) : (
              <Typography
                component="a"
                href={item.link}
                target="_blank"
                rel="noopener noreferrer"
                sx={linkSx}
              >
                {item.label}
              </Typography>
            )}
            {index < items.length - 1 && (
              <Typography component="span" sx={dotSx}>
                ·
              </Typography>
            )}
          </Box>
        ))}
      </Grid>

      <Dialog
        open={Boolean(modalType)}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ position: 'relative' }}>
          {modalTitleMap[modalType] || ''}
          <IconButton
            onClick={handleClose}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          {modalContentMap[modalType] || null}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Legals;
